import React, { useEffect } from "react";

import { ConnectedResultsView } from "../results/results-view/ConnectedResultsView";
import { DeviceTesterTestState } from "../../types/Device.types";
import { useDeviceTesterStateContext } from "../device-tester-context-provider/DeviceTesterContextProvider";
import { ConnectedAudioTestView } from "../audio-test/audio-test-view/ConnectedAudioTestView";
import { ConnectedTestCompleted } from "../test-completed/ConnectedTestCompleted";
import { usePlatformTypeContext } from "../platform-type-provider/PlatformTypeProvider";
import { startLoggingAppSession } from "../telemetry/utils/trackAppSession";

import { logCheckAuthSession } from "./DeviceTester.telemetry";
export const DeviceTester: React.FC = () => {
  const {
    deviceTesterState,
    setDeviceDetails,
    setNetworkConnectionListener,
    checkBrowserSupported,
  } = useDeviceTesterStateContext();

  const { isMobile } = usePlatformTypeContext();

  // On component initialization get device info and set default devices
  useEffect(() => {
    checkBrowserSupported();
    setDeviceDetails();
    setNetworkConnectionListener();
  }, []);

  /**
  Log auth session after device info is fetched to ensure the session
  context URL is processed if it exists
  */
  useEffect(() => {
    if (deviceTesterState.isInfoFetched) {
      logCheckAuthSession();
    }
  }, [deviceTesterState.isInfoFetched]);

  useEffect(() => {
    startLoggingAppSession();
  }, []);

  if (
    deviceTesterState.deviceTesterTestState === DeviceTesterTestState.AUDIO &&
    isMobile
  ) {
    return <ConnectedAudioTestView />;
  } else if (
    deviceTesterState.deviceTesterTestState === DeviceTesterTestState.COMPLETE
  ) {
    return <ConnectedTestCompleted />;
  } else {
    return <ConnectedResultsView />;
  }
};
